module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_features_01-34edf8e3fe36a86bd73fb3f8f95910e4.png";